import { useCallback, useContext } from 'react';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useNavigate } from 'react-router-dom';
import { SELLING_PORTFOLIO_ROUTE } from 'data/global';

export default function useViewPortfolioAs() {
  const { isSuperAdmin, isEnterpriseHead } = useContext(CurrentUserContext);

  const navigate = useNavigate();

  return useCallback(
    (userId: string, userFullName: string) => {
      if (!isSuperAdmin && !isEnterpriseHead) return;

      const search = new URLSearchParams({
        viewAsUserId: userId,
        viewAsUserName: userFullName,
      }).toString();

      navigate({
        pathname: SELLING_PORTFOLIO_ROUTE,
        search,
      });
    },
    [isEnterpriseHead, isSuperAdmin, navigate],
  );
}
